import React from 'react'
import "./index.css"

export default function Experience() {
    return (
        <section id="experience" className="section is-medium">
            <h1 className="title is-family-code has-text-green">Where I've Worked</h1>
            <div className="columns">
            <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img src="https://media-exp1.licdn.com/dms/image/C560BAQEE8HP-F2fOMw/company-logo_100_100/0/1625164980744?e=1675900800&v=beta&t=xbLjBrm3BYbk1SOaaA50QyqC5bxgY65j1e2gQosRC3U" alt="" />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Qorvo</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">@Software Engineer<span className='is-size-7 is-family-code'><br />June 2023 - Present</span></p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                Developing a web based tool (QTR), using ReactJs, Javascript and Web API's. Also supporting QMRFT for automated driver generation tool with RF devices testing using unit test cases developed using NUNIT framework.
                                <br />Technologies: Javascript,C#,.Net 
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img src="https://media-exp1.licdn.com/dms/image/C560BAQEE8HP-F2fOMw/company-logo_100_100/0/1625164980744?e=1675900800&v=beta&t=xbLjBrm3BYbk1SOaaA50QyqC5bxgY65j1e2gQosRC3U" alt="" />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Qorvo</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">@Software Engineer Intern<span className='is-size-7 is-family-code'><br />May 2022 - May 2023</span></p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                Developed a tool to process Qorvo internal PCF programming file,Rf optimizer and generated RF driver (RFFE settings) files for PA,LNA,ASM,Coupler components in the QCOM format and collaborate in development of ‘Automated RF Driver Creation’ (C/C++).
                                Also developed unit test cases using NUnit framework
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img src="https://media-exp1.licdn.com/dms/image/C4D0BAQFLRyQ6olfOcg/company-logo_100_100/0/1661143039579?e=1675900800&v=beta&t=2ndazp8pdDPNt60OwAZq6K9-yZtGmCDu_q5prhi_0Lw" alt="" />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Fractal Analytics</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">@Senior Software Engineer<span className='is-size-7'><br />Mar 2019 - Jun 2021</span></p>
                                </div>
                            </div>


                            <div className="content has-text-light is-family-code">

                                Experienced in developing forecasting web application which is based on analytics over data inputs and results represented using tables, different graphs and charts.
                                Foresient.Designed and Implemented Schema and REST API’s in demand forecasting platform for users.Implemented unit test cases.

                            </div>
                        </div>
                    </div>
                </div>
                <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img src="https://media-exp1.licdn.com/dms/image/C560BAQEU13NlThQ6VA/company-logo_100_100/0/1628605272020?e=1675900800&v=beta&t=Egjj8PNHQ3NBVa724-MlexzyEaZ8Q-wThXROsu9AZVo" alt="" />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Tavisca Solutions</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">@Software Developer<span className='is-size-7 is-family-code'><br />Aug 2016 - Feb 2019</span></p>
                                </div>
                            </div>

                            <div className="content has-text-light is-family-code">
                                Worked Real-Time Hotel Mapping And Descriptive Content Delivery System(Clarifi) This project provides a technology solution aimed to resolve the inconsistent distribution of hotel content across major hotel content providers.
                                • Product enhancing with new feature developed using C# and .Net technologies.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
